import React from 'react'

import {DownArrow, UpArrow} from "./Icons";


export default ({value, opacity}) => {

    if(value === 1) {
        return <UpArrow opacity={opacity}/>
    }
    else if(value -1) {
        return <DownArrow opacity={opacity}/>
    }
    else {
        return <span></span>
    }
}